import { EonUiInput, EonUiTagPill } from "@eon-ui/eon-ui-components-react";
import React, { useMemo, useState } from "react";
import { useTranslation } from "@me8eon/translation";
type Props = {
    feedbackText: string
    setFeedbackText: (v: string) => void
    loading?: boolean;
}

export const DislikeOptions = (props: Props) => {
    const { setFeedbackText, loading } = props;
    const [freeText, setFreeText] = useState("");
    const t = useTranslation();
    const suggestions = useMemo(() => [
        t("chatBot.irelevantContent"),
        t("chatBot.lackOfDetail"),
        t("chatBot.incorrectInformation"),
    ], [t]);

    return (
        <div className="feedback-form">

            <div className="label-section">
                {t(
                    "chatBot.wentWrong"
                )}
            </div>
            <div>
                {suggestions.map(
                    (item: string, index: number) => (
                        <EonUiTagPill
                            filter-name={item}
                            key={index}
                            text={item}
                            class="feedback-tag"
                            scheme="neutral800"
                            isDisabled={loading}
                            onClick={() => {
                                setFeedbackText(item)
                            }}
                        ></EonUiTagPill>
                    ),
                )}
            </div>
            <div className="text-area-wrapper">
                <EonUiInput
                    className="feedback-input"
                    value={freeText}
                    disabled={loading}
                    type="text"
                    placeholder={t("chatBot.feedbackPrompt")}
                    onValueChanged={(e) =>
                        setFreeText(e.target.value)
                    }
                    size="small"
                    trailingIconName="send"
                    onIconClick={() => setFeedbackText(freeText)}
                    onKeyDown={(evt) => {
                        if (evt.key === "Enter") {
                            setFeedbackText(freeText)
                        }
                    }}
                />
            </div>
            <div className="respect-privacy">
                {t("chatBot.privacyMsg")}
            </div>
        </div>
    )
}